<template>
  <div id="shareCard" v-show="isShowCard">
    <div class="mask" @click="hideCard"></div>
    <div class="shareCard-main">
      <p>保存成功！</p>
      <div class="link-input">
        <p>{{ linkTxt }}</p>
      </div>
      <div class="copy-btn" @click="handleCopyLink">{{ shareLink }}</div>
      <div class="share-btn" @click="handleWxShare">
        <i></i>点击右上角分享给微信好友~
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowCard: false,
      linkTxt: "",
      shareLink: "复制分享链接",
    };
  },
  methods: {
    hideCard() {
      this.isShowCard = false;
    },
    showCard() {
      this.isShowCard = true;
    },
    handleCopyLink() {
      // 复制链接
      console.log("复制分享链接");
      this.shareLink = " 已复制分享链接";
      let oURI = document.createElement("input");
      oURI.value = this.linkTxt;
      document.body.appendChild(oURI);
      oURI.select();
      document.execCommand("Copy");
      document.body.removeChild(oURI);
    },
    handleWxShare() {
      // 调用wxapp
      console.log("分享给微信好友");
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/less/shareCard.less";
</style>
